module.exports = __webpack_public_path__ + "img/pointRule.22fb3dce.png";